<template>
  <div>
    <b-dropdown
      class="basket-selector"
      :class="{
        'basket-selector_scroll': options.length > 3
      }"
      toggle-class="basket-selector__toggle d-flex align-items-center px-0"
      variant="transparent"
      right
      no-caret
      @show="onShow"
      @hide="onHide"
    >
      <template #button-content>
        <span class="mr-2">{{ placeholder }}</span>
        <SwitchIcon
          v-if="!disabled"
          :is-active="isOpened"
          variant="dark"
          size="9"
        />
      </template>

      <b-dropdown-item
        v-for="option in options"
        :key="option.value"
        class="basket-selector__item"
        link-class="px-2 py-2"
        @click="handleSelection(option.value)"
      >
        <div class="d-flex align-items-center">
          {{ option.text }}
        </div>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import { isEmpty } from 'lodash';
import SwitchIcon from '@/components/Elements/SwitchIcon';

export default {
  name: 'BasketCustomSelector',

  components: {
    SwitchIcon
  },

  props: {
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    placeholder: {
      type: String,
      default: '',
      validate(val) {
        return isEmpty(val);
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isOpened: false
    };
  },

  methods: {
    onShow() {
      this.isOpened = true;
    },
    onHide() {
      this.isOpened = false;
    },
    handleSelection(value) {
      this.$emit('input', value);

      this.$emit('change', value);
    }
  }
};
</script>

<style lang="scss">
.basket-selector {
  &__toggle:focus {
    box-shadow: none;
  }

  &_scroll {
    .dropdown-menu {
      max-height: 135px;
      overflow-y: scroll;
    }
  }

  .dropdown-menu {
    padding: 0;
    border-radius: 8px;

    .dropdown-item {
      &:hover {
        border-radius: 8px;
        background-color: rgba(221, 202, 109, 0.15);
      }
    }
  }
}
</style>
